import { Box, Image } from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../constant";

const GameTag = ({ game_tags_props = [], isLongLayout } = {}) => {
  return (
    <Box
      position={`absolute`}
      top={"0.2em"}
      left={"50%"}
      transform={"translateX(-50%)"}
      zIndex={`10`}
      display="flex"
      gap="5px"
      w="4em"
    >
      {game_tags_props?.map((tag) => {
        const split_tag = tag?.split("_");
        const tag_name = split_tag?.[0];

        const isHot = tag_name === "hot";

        return isHot ? (
          <Image src={`${COMMON_WEB_PATH}/c3-layout/gameType/Hot_tag.png`} />
        ) : null;
      })}
    </Box>
  );
};

export default GameTag;
